import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotifications } from '../context/NotificationContext';

function fmtTime(unix) {
  if (!unix) return '';
  const d = new Date(parseInt(unix) * 1000);
  return d.toLocaleString('en-MY', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false });
}

export default function NotificationBell() {
  const { history, historyUnread, historyClicked, markHistoryRead, markHistoryItemClicked } = useNotifications();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    function handler(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  function toggle() {
    setOpen(v => !v);
    if (!open) markHistoryRead();
  }

  function goTo(h) {
    setOpen(false);
    markHistoryItemClicked(h.id);
    const path = h.htype === 'W' ? `/warranty/${h.jobid}/edit` : `/jobs/${h.jobid}/edit`;
    navigate(path);
  }

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button onClick={toggle} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px 8px', position: 'relative', color: '#6c757d', display: 'flex', alignItems: 'center' }}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
          <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
        </svg>
        {historyUnread > 0 && (
          <span style={{ position: 'absolute', top: 0, right: 2, width: 8, height: 8, borderRadius: '50%', background: '#e74a3b', border: '1.5px solid #fff' }} />
        )}
      </button>

      {open && (
        <div style={{ position: 'absolute', right: 0, top: '110%', width: 320, background: '#fff', borderRadius: 10, boxShadow: '0 8px 24px rgba(0,0,0,0.12)', zIndex: 1000, overflow: 'hidden' }}>
          <div style={{ padding: '12px 16px', borderBottom: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: 13, fontWeight: 500, color: '#1a1a2e' }}>History</span>
            <span style={{ fontSize: 12, color: '#aaa' }}>{history.length} entries</span>
          </div>
          <div style={{ maxHeight: 360, overflowY: 'auto' }}>
            {history.length === 0 && (
              <div style={{ padding: '24px 16px', textAlign: 'center', color: '#aaa', fontSize: 13 }}>No history yet</div>
            )}
            {history.map((h, i) => {
              const clicked = historyClicked.has(String(h.id));
              return (
                <div key={h.id || i} onClick={() => goTo(h)}
                  style={{ padding: '10px 16px', borderBottom: '1px solid #f8f8f8', display: 'flex', gap: 10, alignItems: 'flex-start', cursor: 'pointer', background: clicked ? '#f8f9fa' : '#fff' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#f0f0f0'}
                  onMouseLeave={e => e.currentTarget.style.background = clicked ? '#f8f9fa' : '#fff'}>
                  <div style={{ width: 8, height: 8, borderRadius: '50%', background: clicked ? '#ccc' : (h.htype === 'W' ? '#f6c23e' : '#4e73df'), marginTop: 5, flexShrink: 0 }} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 12, color: clicked ? '#aaa' : '#444', lineHeight: 1.4 }} dangerouslySetInnerHTML={{ __html: h.description }} />
                    <div style={{ fontSize: 11, color: '#bbb', marginTop: 3 }}>
                      {h.jobid} · {h.htype === 'W' ? 'Warranty' : 'Job'} · {fmtTime(h.time)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
